import { render } from "./Main-help.vue?vue&type=template&id=1975a18c&scoped=true"
import script from "./Main-help.vue?vue&type=script&lang=js"
export * from "./Main-help.vue?vue&type=script&lang=js"

import "./Main-help.vue?vue&type=style&index=0&id=1975a18c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1975a18c"]])

export default __exports__